import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes, Variants } from 'shared/components/ui/button';
import { GridContainer } from 'shared/components/ui/grid-container';
import { Paths } from 'shared/routes/paths';

import * as Styled from './generic-error.style';

export enum GenericErrorVariants {
  Generic = 'generic',
  AccountUnavailable = 'account-unavailable',
  NotFound = 'not-found',
}

const reload = () => window.location.reload();
const navigateHome = () => {
  window.location.href = Paths.Home;
};

const variantConfig = {
  [GenericErrorVariants.Generic]: {
    title: 'pages.error.title',
    subtitle: 'pages.error.subtitle',
    description: 'pages.error.description',
    primaryLabel: 'pages.error.interactions.retry.label',
    onPrimary: reload,
  },
  [GenericErrorVariants.AccountUnavailable]: {
    title: 'pages.error.title',
    subtitle: 'pages.error.account-unavailable.subtitle',
    description: 'pages.error.account-unavailable.description',
    primaryLabel: 'pages.error.interactions.retry.label',
    onPrimary: reload,
  },
  [GenericErrorVariants.NotFound]: {
    title: 'pages.not-found.title',
    subtitle: 'pages.not-found.subtitle',
    description: 'pages.not-found.description',
    primaryLabel: 'pages.not-found.interactions.back-home.label',
    onPrimary: navigateHome,
  },
};

export type GenericErrorProps = {
  errors: string[];
  variant?: GenericErrorVariants;
};

export const GenericError: React.FC<GenericErrorProps> = ({
  errors,
  variant = GenericErrorVariants.Generic,
}) => {
  const { t } = useTranslation();
  const config = variantConfig[variant];

  const onContact = () => {
    window.location.href = `mailto:support@griply.app?body=Please don't remove this line "${errors.join(', ')}".`;
  };

  return (
    <Styled.Container>
      <GridContainer>
        <Styled.ContentContainer>
          <Styled.Content>
            <Styled.Body>
              <Typography variant="h1" component="span">
                {t(config.title)}
              </Typography>
              <Typography variant="h5" component="span">
                {t(config.subtitle)}
              </Typography>
              <Typography variant="body2" component="span">
                {t(config.description)}
              </Typography>
            </Styled.Body>

            {errors.map((errorId) => (
              <Styled.IssueLabel key={errorId}>{errorId}</Styled.IssueLabel>
            ))}
          </Styled.Content>

          <Styled.Interactions>
            <Button onClick={config.onPrimary} size={Sizes.Medium}>
              {t(config.primaryLabel)}
            </Button>
            <Button
              variant={Variants.Text}
              size={Sizes.Medium}
              onClick={onContact}
            >
              {t('pages.error.interactions.contact-support.label')}
            </Button>
          </Styled.Interactions>
        </Styled.ContentContainer>
      </GridContainer>
    </Styled.Container>
  );
};
